var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@mp/locale';
import "./Sidebar.scss";
export default function MarketingSidebar() {
    return (_jsxs("div", __assign({ className: "mp-sidebar" }, { children: [_jsx("div", __assign({ className: "mp-sidebar-title" }, { children: t("CAPTURE_SERVICES.SIDEBAR.WHATS_INCLUDED") })), _jsx("div", __assign({ className: "mp-sidebar-bullets-container" }, { children: _jsx("div", __assign({ className: "mp-sidebar-bullets" }, { children: _jsxs("ul", { children: [_jsx("li", { children: t("CAPTURE_SERVICES.SIDEBAR.BULLETS.0") }), _jsx("li", { children: t("CAPTURE_SERVICES.SIDEBAR.BULLETS.1") }), _jsx("li", { children: t("CAPTURE_SERVICES.SIDEBAR.BULLETS.2") }), _jsx("li", { children: t("CAPTURE_SERVICES.SIDEBAR.BULLETS.3") }), _jsx("li", { children: t("CAPTURE_SERVICES.SIDEBAR.BULLETS.4") })] }) })) }))] })));
}
